import { render, staticRenderFns } from "./OpportunisticSavingInsight.vue?vue&type=template&id=4df8d7ea&scoped=true"
import script from "./OpportunisticSavingInsight.vue?vue&type=script&lang=js"
export * from "./OpportunisticSavingInsight.vue?vue&type=script&lang=js"
import style0 from "./OpportunisticSavingInsight.vue?vue&type=style&index=0&id=4df8d7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8d7ea",
  null
  
)

export default component.exports